'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--CreativeCloud';

var EntypoCreativeCloud = function EntypoCreativeCloud(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M12.6,3c-1.966,0-3.74,0.813-5.012,2.119C7.204,5.041,6.807,5,6.4,5c-3.314,0-6,2.686-6,6s2.686,6,6,6h6.2c3.866,0,7-3.134,7-7C19.6,6.134,16.466,3,12.6,3z M6.4,15.728c-1.263,0-2.45-0.492-3.344-1.385C2.164,13.45,1.672,12.262,1.672,11s0.492-2.45,1.385-3.343C3.95,6.764,5.137,6.272,6.4,6.272s2.45,0.492,3.344,1.385l1.874,1.875c0.273,0.273,0.273,0.716,0,0.99c-0.274,0.274-0.718,0.273-0.99,0L8.754,8.646c-1.258-1.256-3.449-1.256-4.707,0C3.418,9.276,3.072,10.111,3.072,11s0.346,1.724,0.975,2.354c0.785,0.784,1.933,1.078,2.991,0.884c0.324,0.424,0.689,0.815,1.1,1.155C7.591,15.609,7.005,15.728,6.4,15.728z M16.689,14.089c-1.093,1.092-2.545,1.694-4.089,1.694c-1.545,0-2.997-0.602-4.09-1.694L5.801,11.38c-0.273-0.273-0.273-0.717,0-0.99s0.717-0.273,0.99,0l2.709,2.709c0.828,0.828,1.929,1.284,3.1,1.284s2.271-0.456,3.099-1.284S16.983,11.17,16.983,10s-0.456-2.271-1.284-3.099S13.771,5.617,12.6,5.617c-0.873,0-1.707,0.255-2.418,0.727C9.801,6.035,9.38,5.775,8.931,5.565c1.035-0.858,2.309-1.349,3.67-1.349c1.544,0,2.996,0.602,4.089,1.694c1.093,1.093,1.694,2.545,1.694,4.089S17.782,12.997,16.689,14.089z' })
    );
};

exports.default = EntypoCreativeCloud;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/CreativeCloud.js
// module id = 7294
// module chunks = 0